export default __webpack_public_path__ + "static/media/dummy.3e277125.jpeg";